enum AlphabeticCountriesCodes {
  US = 'US',
}

export { AlphabeticCountriesCodes };
